import { createReactComponent } from '@tabler/icons-react';

export const IconCustomTablePivot = createReactComponent(
  'outline',
  'customTablePivot',
  'CustomTablePivot',
  [
    [
      'path',
      {
        key: 'customTablePivot-path-1',
        d: 'M2.7,9.6h18v-5c0-.5-.2-1-.6-1.4-.4-.4-.9-.6-1.4-.6H4.7c-.5,0-1,.2-1.4.6-.4.4-.6.9-.6,1.4v14c0,.5.2,1,.6,1.4.4.4.9.6,1.4.6h5V2.6M13.5,20.4h5c.5,0,1-.2,1.4-.6.4-.4.6-.9.6-1.4v-5M13.5,20.4l2,2M13.5,20.4l2-2M20.5,13.4l-2,2M20.5,13.4l2,2',
      },
    ],
  ]
);
